import dayjs from 'dayjs';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { useParams, Switch, Route } from 'react-router-dom';
import { MemberSlavePage } from 'src/features/home/features/group/features/member-slave.page';

import { routes } from 'src/routes';
import { Block } from 'src/ui/atoms/block';
import { Page } from 'src/ui/templates/page';
import { fetchGroupFx, group$ } from 'src/store/group.store';
import { GroupMainPage } from 'src/features/home/features/group/features/group-main.page';
import { GroupAdminPage } from 'src/features/home/features/group/features/group-admin.page';

const block = css`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	background: transparent;
`;
const Circle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px solid white;
	border-radius: 50%;
	height: 120px;
	width: 120px;
	color: white;
	
	& > *:nth-child(2) {
		margin-top: 8px;
		font-size: 18px;
	}
`;

export const GroupPage = () => {
	const group = useStore(group$);
	const params = useParams<{ id: string }>();

	useEffect(() => {
		fetchGroupFx({ group: params.id });
	}, []);

	const membersCount = group?.members;
	const distributionDate = group?.distribution_date && dayjs(group?.distribution_date)
		.format('DD.MM.YYYY');

	return (
		<Page title={group?.caption}>
			<Block className={block}>
				<Circle>
					<span>Members</span>
					<span>{membersCount}</span>
				</Circle>
				<Circle>
					<span>Distribution</span>
					<span>{distributionDate}</span>
				</Circle>
			</Block>
			<Block>
				<Switch>
					<Route path={routes.root.home.group.main.path} exact={true}>
						<GroupMainPage group={group}/>
					</Route>
					<Route path={routes.root.home.group.admin.path}>
						<GroupAdminPage/>
					</Route>
					<Route path={routes.root.home.group.slave.path}>
						<MemberSlavePage/>
					</Route>
				</Switch>
			</Block>
		</Page>
	);
};
